// @ts-ignore
import React from 'react';
// @ts-ignore
import ReactDOM from 'react-dom/client';
import './styles/index.css';

import reportWebVitals from './reportWebVitals';

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <App/>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
